import React from 'react';
// eslint-disable-next-line no-restricted-imports
import ThreadsDropdownLink from 'plaid-threads/DropdownLink';

const DropdownLink = (props) => {
  return <ThreadsDropdownLink {...props} />;
};

export default DropdownLink;
